import { Fonts } from '../../config/theme';
import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 80vw;
  .listing_page {
    .mini-title {
      width: 800px;
      font-family: ${Fonts.secondary};
      font-weight: 500;
      font-size: 16px;
      color: #809399;
      padding: 0px;
      margin: 0px;
      display: flex;
    }
    .left-heading {
      width: 25%;
      .heading {
        font-family: ${Fonts.primary};
        font-weight: 700;
        font-size: 25px;
        color: var(--color-dark);
        display: flex;
        margin: 5px 0px;
      }
    }
    .right-heading {
      width: 75%;

      .mini-title {
        float: right;
      }
      .listing-actions {
        display: flex;
        justify-content: end;
        .select_status {
          width: '50%';
        }

        button {
          margin: 0px 5px;
          a {
            text-decoration: none;
          }
        }
      }
    }

    /* Listing Review Detail */
    .top-row {
      display: flex;
      align-items: flex-start;
      > button {
        margin-top: 0;
      }
      .customer-name-id {
        margin-left: 20px;
        h2 {
          font-size: 25px;
          font-weight: 700;
          color: var(--color-dark);
          display: flex;
          align-items: center;
          span {
            margin-left: 10px;
          }
          .type {
            padding: 5px 8px;
            background: #2684ff;
            border-radius: 5px;
            color: var(--color-light);
            font-size: 11px;
            font-weight: 500;
            margin-left: 15px;
          }
        }
        p {
          margin-top: 7px;
          color: #ccd4d6;
          font-size: 15px;
          font-weight: 700;
          text-transform: uppercase;
        }
      }
    }
    .container {
      .left-side {
        .grid-row-three {
          padding: 20px;
          background: var(--color-light);
          border-radius: 5px;
          box-shadow: 0px 5px 10px -2px rgba(196, 214, 220, 0.25);
          margin-top: 30px;
          .grid-column {
            > button {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 10px;
              text-transform: uppercase;
              background: #f2f4f5;
              border: none;
              outline: none;
              border-radius: 5px;
              cursor: pointer;
              font-size: 13px;
              font-weight: 600;
              color: var(--color-dark);
              margin-bottom: 15px;
            }
            .dataPanel {
              overflow: hidden;
              margin: 10px;
              .center-text {
                text-align: center;
              }
              span {
                font-family: ${Fonts.secondary};
                font-weight: 600;
                font-size: 12px;
                text-transform: uppercase;
                color: var(--color-text-dark);

                .green {
                  color: var(--app-color-dark);
                }
              }
              .customer-info {
                .row-3 {
                  background: #fff;
                  table {
                    width: 100%;
                    background: #fff;
                    border-radius: 5px;
                    border-collapse: collapse;
                    display: block;
                    thead {
                      display: block;
                      padding: 15px 20px;
                      background: #f2f4f5;
                      box-shadow: 0px 1px 1px rgba(0, 39, 51, 0.25);

                      tr {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        th {
                          font-size: 13px;
                          font-weight: 700;
                          color: var(--color-dark);
                          text-align: left;
                          :last-child {
                            text-align: right;
                          }
                        }
                      }
                    }
                    tbody {
                      display: block;
                      tr {
                        cursor: pointer;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 15px 20px;
                        :hover {
                          background: rgba(90, 179, 168, 0.15);
                        }
                        :not(:last-child) {
                          border-bottom: 1px solid rgba(0, 39, 51, 0.08);
                        }
                        td {
                          font-size: 13px;
                          font-weight: 500;
                          color: var(--color-dark);
                          text-align: left;
                          :last-child {
                            text-align: right;
                          }
                          img {
                            border-radius: 5px;
                            width: 44px;
                            height: 44px;
                          }
                        }
                        .more {
                          position: relative;
                          > button {
                            font-size: 18px;
                            color: #4c6870;
                            background: transparent;
                            border: none;
                            border-radius: 50%;
                            display: inline-flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                            padding: 10px;
                          }
                        }
                        .dropdown {
                          position: absolute;
                          min-width: 200px;
                          right: 0;
                          background: var(--color-light);
                          border-radius: 5px;
                          padding: 5px;
                          z-index: 1;
                          border: 1px solid rgba(204, 212, 214, 0.5);
                          box-shadow: 0px 8px 12px rgba(0, 39, 51, 0.12);
                          button {
                            width: 100%;
                            border: none;
                            padding: 8px 10px;
                            outline: none;
                            font-size: 15px;
                            font-weight: 400;
                            color: var(--color-dark);
                            background: transparent;
                            text-align: left;
                            border-radius: 5px;
                            :hover {
                              cursor: pointer;
                              background: #f2f4f5;
                            }
                          }
                        }
                      }
                      .active-row {
                        background: rgba(90, 179, 168, 0.15);
                      }
                    }
                  }
                }
                .form-check-input:checked {
                  background-color: #05ae4b;
                }
                table {
                  border-radius: 5px;
                }
                thead {
                  background: #f2f4f5;
                  box-shadow: 0px 1px 1px rgba(0, 39, 51, 0.25);
                  font-weight: 700;
                  font-size: 13px;
                  color: #002733;
                }
                tbody {
                  background: rgba(220, 238, 221, 0.5);
                  font-size: 15px;
                  color: #002733;
                }
                .row {
                  display: grid;
                  grid-template-columns: 2fr 4fr 4fr 2fr;
                  grid-gap: 5px 10px;
                  font-size: 13px;
                  font-weight: 500;
                  line-height: 1.8;
                  .left-column {
                    color: grey;
                  }
                  .right-column {
                    color: var(--color-dark);
                  }
                  .third-column {
                    color: var(--color-dark);
                    .images {
                      justify-content: center;
                    }
                  }
                  .left-column.header {
                    font-weight: bold;
                    text-align: center;
                  }
                  .right-column.header {
                    font-weight: bold;
                    text-align: center;
                    border-bottom: 1px solid lightgray;
                  }
                  .third-column.header {
                    font-weight: bold;
                    text-align: center;
                    border-bottom: 1px solid lightgray;
                  }
                  .left-column.tab {
                    background-color: #fafafa;
                    padding: 10px;
                  }
                  .right-column.tab {
                    padding: 10px;
                  }
                  .third-column.tab {
                    padding: 10px;
                  }
                  .forth-column.tab {
                    padding: 10px;
                    font-weight: bold;
                  }
                  .images {
                    display: flex;
                    justify-content: start;
                    cursor: pointer;
                    img {
                      margin-right: 10px;
                      width: 50px !important;
                      height: 50px !important;
                      border-radius: 5px;
                      object-fit: cover !important;
                    }
                  }
                  .right-columns {
                    display: grid;
                    grid-template-columns: 15% 50%;
                    /* border: 1px solid #000; */
                  }
                }
              }
              .customer-info.row-2 {
                .row {
                  display: grid;
                  grid-template-columns: 3fr 9fr;
                }
              }
              .time-details {
                background: rgba(90, 179, 168, 0.15);
                border-radius: 5px;
                margin-top: 20px;
                padding: 15px;
                h5 {
                  font-weight: 600;
                  font-size: 12px;
                  line-height: 120%;
                  color: #4c687080;
                }
              }
              .order-list {
                .row {
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  :not(:last-child) {
                    margin-bottom: 10px;
                  }
                  span {
                    color: var(--color-dark);
                    font-size: 17px;
                    font-weight: 400;
                  }
                  button {
                    border: none;
                    background: transparent;
                    cursor: pointer;
                    font-size: 15px;
                    color: #ccd4d6;
                    margin: 0 10px;
                  }
                }
              }
            }
          }
        }
      }
      .right-side {
        padding: 20px;
        margin-top: 30px;
        margin-top: 20px;
        margin-left: 20px;
        background-color: white;

        h3 {
          font-size: 19px;
          font-weight: 600;
          color: #002733;
          text-transform: capitalize;
          padding: 5px 0px;
          /* background-color: var(--color-light-gray-low); */
          border-radius: 5px;
        }
        p {
          color: #809399;
        }
        .order-timeline {
          margin-top: 30px;
          .row {
            font-family: ${Fonts.secondary};
            /* padding-left: 40px; */
            position: relative;
            .card.canceled {
              color: var(--color-dark);
            }
            .card {
              display: flex;
              color: #ccd4d6;
              font-weight: 400;
              text-transform: uppercase;
              position: relative;
              margin-bottom: 20px;
              h4 {
                font-size: 13px;
                line-height: 2;
              }
              p {
                font-size: 11px;
              }
            }
            .completed {
              color: var(--color-dark);
              position: relative;
            }
          }
        }
      }
    }
  }
`;

export const DropdownStyled = styled.div`
  .dropdown-container {
    &.show button {
      background-color: #ccd4d6 !important;
    }
    .dropdown-menu {
      border: 1px solid rgba(204, 212, 214, 0.3);
      box-shadow:
        0px 8px 24px rgba(0, 39, 51, 0.1),
        0px 4px 4px rgba(0, 39, 51, 0.04);
      border-radius: 5px;
    }
    button {
      padding: 10px;
      font-weight: 500;
      font-size: 13px;
      min-width: 300px;
      border-radius: 5px;
      color: #4c6870;
      position: relative;
      &:focus {
        box-shadow: none !important;
      }
      &.chevron-down:before {
        content: '';
        position: absolute;
        top: 11px;
        right: 10px;
        border: solid #4c6870;
        border-width: 0 1px 1px 0;
        display: inline-block;
        transform: rotate(45deg);
        padding: 3px;
      }
    }
    a {
      font-weight: 400;
      font-size: 14px;
      color: #002733;
      padding-top: 8px;
      padding-bottom: 8px;
      &.active {
        background: transparent;
      }
    }
  }
`;
